import {
  faGraduationCap,
  faLaptopBinary,
  faMessageSmile,
  faNotebook,
  faQuestion,
  faScrewdriverWrench,
} from '@fortawesome/pro-solid-svg-icons'

import type { SeriesQuickLinksData } from '@/common/services/seriesPage/types'

import { useUser } from '@/client/context/user'
import { getExperimentArm } from '@/client/services/experiments/session-simulator'
import * as url from '@/client/services/url'
import { hasUserRole } from '@/client/services/user'

import QuickLinks from '@/components/QuickLinks'

export default function SeriesQuickLinks({
  series,
}: {
  series: SeriesQuickLinksData
}): JSX.Element | null {
  const user = useUser()

  const seriesId = series.id
  const isUserHost = series.viewer.isHost

  const isSATSeries = series.isSATSeries

  const curriculumUrl = series.curriculumUrl

  const simulatorExperimentArm = getExperimentArm(user.id)

  const links = [
    ...(curriculumUrl != null && (isUserHost || hasUserRole(user, 'admin:super'))
      ? [
          {
            title: 'Curriculum',
            href: curriculumUrl,
            icon: faGraduationCap,
            bgColor: 'green.solid',
            iconColor: 'green.contrast',
          },
        ]
      : []),
    ...(isSATSeries
      ? [
          {
            icon: faQuestion,
            bgColor: 'purple.solid',
            iconColor: 'purple.contrast',
            title: isUserHost ? 'Tutor FAQ' : 'SAT Bootcamp FAQ',
            href: url.faq.getUrl(isUserHost ? 'sat-bootcamp-tutors' : 'sat-bootcamp'),
          },
          {
            title: 'Learner Handbook',
            href: url.getSATBootcampLearnerHandbookUrl(),
            icon: faNotebook,
            bgColor: 'pink.solid',
            iconColor: 'pink.contrast',
          },
          ...(isUserHost
            ? [
                {
                  title: 'Tutor Troubleshooting Guide',
                  href: url.getSATBootcampCurriculumUrl('troubleshooting-guide-60'),
                  icon: faScrewdriverWrench,
                  bgColor: 'blue.solid',
                  iconColor: 'blue.contrast',
                },
              ]
            : []),
        ]
      : []),
    ...(isUserHost && simulatorExperimentArm === 'experiment'
      ? [
          {
            title: 'Session Simulator',
            href: `${url.getSessionSimulatorUrl()}?src=series-quicklinks`,
            icon: faLaptopBinary,
            bgColor: 'orange.solid',
            iconColor: 'orange.contrast',
          },
        ]
      : []),
    ...(isUserHost
      ? [
          {
            title: 'My Feedback',
            href: url.getTutorFeedbackUrl({ seriesId: seriesId ?? 0 }),
            icon: faMessageSmile,
            iconColor: 'green.contrast',
            bgColor: 'green.solid',
          },
        ]
      : []),
  ]
  return links.length === 0 ? null : <QuickLinks links={links} />
}
